// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialIcons_socialLinks__BsCOK","link":"SocialIcons_link__zx46m"};